import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount, inject, onBeforeUnmount } from "vue";
import InlineSvg from "vue-inline-svg";
import { useUserStore } from "@/stores/userStore";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  QRCODE_TIME_SECOND,
  ShowErrorModal,
} from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'QRCode',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const initTimer = QRCODE_TIME_SECOND;
const timer = ref(initTimer);
const timerInterval = ref();
const qrCode = ref("");

onBeforeMount(async () => {
  getQrCode();
  startTimer();
});

onBeforeUnmount(() => {
  stopTimer();
});

const getQrCode = async (event: Event | undefined = undefined) => {
  if (event) {
    updateQrcodeTime(event);
  }
  const qrCodeResult = await userStore.getQrCode();
  if (!qrCodeResult.isSuccess) {
    showErrorModal(
      "QR코드 오류",
      qrCodeResult.errorMessage,
      qrCodeResult.resultCode,
      qrCodeResult.errorTime
    );
  }
  qrCode.value = qrCodeResult.data?.qrCode ?? "";
};

const updateQrcodeTime = (event: Event) => {
  const refreshButtonElement = event.currentTarget as HTMLElement;
  refreshButtonElement.classList.add("rotate");
  setTimeout(() => {
    refreshButtonElement.classList.remove("rotate");
    stopTimer();
    timer.value = initTimer;
    startTimer();
  }, 500);
};

const formattedTimer = (timer: number) => {
  const minutes =
    Math.floor(timer / 60) < 10
      ? `0${Math.floor(timer / 60)}`
      : `${Math.floor(timer / 60)}`;
  const seconds = timer % 60 < 10 ? `0${timer % 60}` : `${timer % 60}`;
  return `${minutes}:${seconds}`;
};
const stopTimer = () => {
  clearInterval(timerInterval.value);
};
const countDown = () => {
  if (timer.value === 0) {
    stopTimer();
    return;
  }
  timer.value -= 1;
};
const startTimer = () => {
  timerInterval.value = setInterval(countDown, 1000);
};

const __returned__ = { userStore, showErrorModal, initTimer, timer, timerInterval, qrCode, getQrCode, updateQrcodeTime, formattedTimer, stopTimer, countDown, startTimer, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})